import { render, staticRenderFns } from "./UpdateUAMUser.vue?vue&type=template&id=1791c0c6"
import script from "./UpdateUAMUser.vue?vue&type=script&lang=js"
export * from "./UpdateUAMUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports